import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useIntl } from 'react-intl';

const DownloadRequestsHeader = ({
  requestsVisible,
  requestsTotal,
  loading,
}) => {
  const intl = useIntl();

  return (
    <header className="page-header">
      <h2 className="page-title">
        <i className="far fa-cart-arrow-down" />
        {intl.formatMessage({ defaultMessage: 'Download requests' })}
      </h2>
      <div className="header-actions users-actions">
        <div className="items-displaying users-displaying">
          {(!loading && requestsTotal > 0) && (
            <span>
              {intl.formatMessage(
                { defaultMessage: '{requestsVisible} of {requestsTotal} requests' },
                { requestsVisible, requestsTotal },
              )}
            </span>
          )}
        </div>
      </div>
    </header>
  );
};

DownloadRequestsHeader.propTypes = {
  requestsVisible: PropTypes.string.isRequired,
  requestsTotal: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default withRouter(DownloadRequestsHeader);
